import React from 'react';
import { Provider } from 'react-redux';
import { store, persistor } from './reducers/configure-store';
import { PersistGate } from 'redux-persist/integration/react'
import CompassApp from './components/compass-app';

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <CompassApp />
    </PersistGate>    
  </Provider>  
);

export default App;
